import { requestDomainSettings } from "../features/requests";
import { defaultDomainCfg, DomainConfiguration } from "./types";
import { getAppCfg } from "./app-cfg";
import { loadI18n } from "./i18n";
import { loadAllowedProjectLists } from "./project/projectslist";
import { loadAssetsI18n } from "../features/assets/assetsI18n";
import { loadViews } from "./views";
import { loadOnboarding } from "../features/onboarding";
import { loadErrorHelp } from "../features/errorHelp";

import { store } from "./state";
import { DOMAIN_CFG } from "./constants";

export async function loadDomainConfigurations() : Promise<void> {
  store.setState(DOMAIN_CFG, defaultDomainCfg);
  const domainCfgState = store.getState(DOMAIN_CFG);
  if (domainCfgState.getValue().initialized === true) {
    return;
  }

  const appCfg = getAppCfg();
  const data = await requestDomainSettings(appCfg.domain, appCfg.domainPath);
  const domainCfg : DomainConfiguration = data;
  domainCfg.initialized = true;
  store.setState(DOMAIN_CFG, { ...domainCfg});

  await loadApplicationFeatures(domainCfg);
  
  console.log(`Loaded Domain and Application Features: ${appCfg.domain}`);
}

export async function loadApplicationFeatures(domainCfg : DomainConfiguration) : Promise<void> {
  await loadAllowedProjectLists(domainCfg.projectSettings.projectListFiles);
  await loadI18n(domainCfg.projectSettings.i18nPath, domainCfg.lang);
  await loadAssetsI18n(domainCfg.projectSettings.assetsI18nPath, domainCfg.lang);
  await loadViews(domainCfg.product.views);
  await loadOnboarding(domainCfg.product.onboarding);
  await loadErrorHelp(domainCfg.product.errorHelp);
}
